export default "__VITE_ASSET__CxuHbZ_Z__"